import React from 'react';
import NewsCard from '../components/NewsCard/NewsCard';

function News() {
  return (
    <div className="news-page">
      <h1>Latest News</h1>
      <NewsCard 
        title="Indosam CC Wins Championship" 
        date="April 05, 2025" 
        content="Indosam CC clinched the title in a thrilling match..." 
      />
      {/* Add more news */}
    </div>
  );
}

export default News;